export const navLinks = [
    { text: "work", path: "/work" },
    { text: "about", path: "/about" },
    { text: "contact", path: "/contact" },
];
